<template>
    <b-container class="sub-layout">
        <div class="loader" v-if="loader">
            <loader />
        </div>

        <div v-if="waitingOnStripe">
            <p class="red">Processing your request... please wait</p>
        </div>

        <div class="select-payment-plan mt-4">
            <h1 v-if="planTrial">Your trial has ended</h1>
            <h1 v-if="!planTrial">Update Plan</h1>
            <p v-if="planTrial">Select a plan to continue using ReadyMsg.</p>

            <b-row align-h="center" class="mt-5">
                <h2>Select a Plan</h2>
            </b-row>
            <div>
                <b-form-group>
                    <b-form-radio-group buttons id="checkboxes1" name="flavour1" v-model="selected" :options="options">
                    </b-form-radio-group>
                </b-form-group>
            </div>

            <!-- <b-row align-h="center"> -->

                <b-row align-h="center">

                <b-col cols="12" sm="10" lg="8">
                    <div ref="card"></div>
                </b-col>

                <b-btn class="sub-btn submit-btn" :disabled="((this.selected == '') || (this.purchaseBtnClicked))" v-on:click="purchase">Purchase</b-btn>
                </b-row>
            <!-- </b-row> -->

            <b-row align-h="end">
                <b-col cols="3">
                <p class="powered-stripe">Powered by Stripe</p>
                </b-col>
            </b-row>

            <div id="error-message"></div>
        </div>

        <div class="pricing-plans">
        <b-row>
            <b-col>
                <b-card class="pricing-card"
                    header="Starter"
                    header-tag="header"
                >
                    <b-card-text><b>$25/mo</b></b-card-text>
                    <!-- <b-card-text>$25/mo (Annual)</b-card-text> -->

                <div>
                    <ul class="list">
                        <li class="list-item">200 Text Messages</li>
                        <li class="list-item">Email Support</li>
                        <li class="list-item"> </li>
                    </ul>
                </div>

                </b-card>
            </b-col>

            <b-col>
                <b-card class="pricing-card"
                    header="Standard"
                    header-tag="header"
                >
                    <b-card-text><b>$55/mo</b></b-card-text>
                    <!-- <b-card-text>$55/mo (Annual)</b-card-text> -->

                <div>
                    <ul class="list">

                        <li class="list-item">500 Text Messages</li>
                        <li class="list-item">Text Marketing (Text Opt-In Customers)</li>
                        <li class="list-item">Email Support</li>
                    </ul>
                </div>

                </b-card>
            </b-col>

            <b-col>
              <b-card class="pricing-card"
                    header="Pro"
                    header-tag="header"
                >
                    <b-card-text><b>$125/mo</b></b-card-text>
                    <!-- <b-card-text>$95/mo (Annual)</b-card-text> -->

                <div>
                    <ul class="list">
                    <li class="list-item">1,500 Text Messages</li>
                    <li class="list-item">Text Marketing (Text Opt-In Customers)</li>
                    <li class="list-item">Email & Phone Support</li>
                    </ul>
                </div>

                </b-card>
            </b-col>
        </b-row>
        </div>
    </b-container>
</template>

<script>
let stripe = Stripe(`pk_live_EAZ5Hi8TMS9SlYuEQoZX8zy200lXgOyOK1`), // live key pk_live_EAZ5Hi8TMS9SlYuEQoZX8zy200lXgOyOK1  test key pk_test_5neDlHthmVkE4ntXiubMbX4V00u2jkXusY
    elements = stripe.elements(),
    card = undefined;

import Loader from "../../components/Loader"
import { db } from '@/main'
import firebase from 'firebase'
import axios from 'axios'
import { truncate } from 'fs';
export default {
    components: {
        Loader
    },
    data() {
        return {
            selected: 'Starter',
            options: ['Starter', 'Standard', 'Pro'],
            stripeToken: null,
            purchaseBtnClicked: false,
            createStripeSubApi: 'https://us-central1-readytextme.cloudfunctions.net/createStripeSubscription',
            loader: false,
            waitingOnStripe: false,
            planTrial: false
        }
    },

    async created() {
        this.waitingOnStripe = false;
        var vueInstance = this;
        const userDoc = await db.collection('users').doc(firebase.auth().currentUser.uid).onSnapshot(async(doc) => {
            const plan = doc.data().plan;

            if ((plan != 'trial') && (plan != '')) {
                // TODO uncomment to re-route users to open if the aren't on trial
                // vueInstance.$router.push({path: '/open'});
                this.planTrial = false;
            }

            if (plan == 'trial') {
                this.planTrial = true;
            }
        })
    },
    beforeMount() {

        let style = {
            base: {
                border: '4px solid #000000',
                borderRadius: '4px',
                color: "#000",
            },

            invalid: {
                // All of the error styles go inside of here.
                color: '#cc4545'
            }

        };

        card = elements.create('card', style);
    },
    mounted: function () {
        card.mount(this.$refs.card);

    },
    beforeDestroy() {
        card.destroy();
    },
    methods: {
        async purchase () {
            // method to create stripe subscription and account
            let self = this;

            this.loader = true;

            let displayError = document.getElementById('error-message');

            stripe.createToken(card).then(async (result) => {
                // Access the token with result.token
                // console.log('token: ' + JSON.stringify(result.token));

                if (result.error) {
                    console.log(result.error);

                    displayError.textContent = JSON.stringify(result.error.message);
                    this.loader = false;
                    return
                } else {
                    this.purchaseBtnClicked = true;
                    displayError.textContent = '';
                    this.stripeToken = result.token;

                    let plan = ''
                    if (this.selected == "Starter") {
                        plan = 'starter';
                    }

                    if (this.selected == "Standard") {
                        plan = 'standard';
                    }

                    if (this.selected == "Pro") {
                        plan = 'pro';
                    }

                    let postContent = {
                        'uid': firebase.auth().currentUser.uid,
                        'pricingPlan': plan,
                        'token': this.stripeToken
                    }

                    // console.log(postContent);
                    // request api to create stripe sub
                    try {
                        await axios.post(
                        this.createStripeSubApi,
                        postContent,
                        {
                            headers: {
                            'Content-Type': 'application/json'
                        },
                        })
                        this.stripeSuccessAlert = true;
                        setTimeout(this.routeToDash, 2000);
                        this.loader = false;
                        //this.purchaseBtnClicked = false;
                        this.waitingOnStripe = true;

                    } catch (error) {
                        console.log(error);
                        this.stripeErrorAlert = true;
                        this.purchaseBtnClicked = false;
                        this.loader = false;
                    }
                }
            });
        },
        routeToDash () {
            this.$router.push({path: '/settings'});
        },
        // buttonActive () {
        //     this.purchaseBtnClicked = false;
        // }
    },
}
</script>

<style scoped>
.StripeElement {
  background-color: white;
  height: 40px;
  padding: 10px 12px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

.hidden {
  visibility: hidden !important;
  transition: all 0.5s ease;
}

.select-payment-plan {

  background-color: #f5f4f4;
  padding: 40px 20px 20px 20px;
  border-radius: 3px;
  /* border: 1px solid #cacaca; */
  box-shadow: 1px 0px 5px 1px #c4c4c4;

}

.enter-card {
  font-size: .8em;
}

.powered-stripe {
  margin-top: 10px;
  font-size: .6em;
  color: #b4b4b4;

}

.sub-layout {
    margin-top: 120px;
}

.price {
    text-align: center;
    display: inline-block;

}
.price-starter {
    /* margin-right: 20px; */
}

.price-standard {
    /* margin-left: 25px; */
    /* padding-left: 4px; */
}

.price-pro {
    /* margin-left: 38px; */
}

#error-message {
  color: #E05555;
  margin-top: 0px;
}

.pricing-plans {
    margin-top: 40px;
    margin-bottom: 100px;

}

.list {
    list-style-type: none;
    margin: 0;
    padding: 0;
    padding-top: 15px;
    border-top: 1px solid #e2e2e2;

}

.list-item {
    text-align: center;
}

.pricing-card {
    background-color: #f5f4f4;
    /* padding: 30px 20px 5px 20px; */

    border-radius: 3px;
    box-shadow: 1px 0px 5px 0px #c4c4c4;
    min-height: 220px;

}

.loader {
    position: fixed;
    width: 350px;
    height: 350px;
    z-index: 100;
    padding-top: 70px;
    /* top: 0; */
    bottom: 30%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #c0c0c0;
    border-radius: 5px;
    transition: all 0.8s ease;
    }

.red {
    /* color: #ffffff; */
    color: #DA2a2a;
}
</style>
